export default {
	isAbsoluteUrl: function (url) {
		if (typeof url === 'string' && url !== '') {
			let absoluteUrlPattern = new RegExp('^(?:[a-z]+:)?//', 'i');
			return absoluteUrlPattern.test(url);
		}
		return false;
	},
	
	isPlainObject: function (val) {
		if (toString.call(val) !== '[object Object]') {
			return false;
		}
		let prototype = Object.getPrototypeOf(val);
		return prototype === null || prototype === Object.prototype;
	},
	
	isFunction: function (val) {
		return toString.call(val) === '[object Function]';
	},
	
	declOfNum: function(number, titles, showNumber) {
		let cases = [2, 0, 1, 1, 1, 2];
		return (showNumber ? number + ' ' : '') + titles[(number%100 > 4 && number%100 < 20) ? 2 : cases[Math.min.apply(this, [number%10, 5])]];
	}
}